/* eslint-disable import/prefer-default-export */
import { parseISO, differenceInHours } from "date-fns";

export function isClose(d) {
  const hoursBeforeStart = differenceInHours(parseISO(d), new Date());

  if (hoursBeforeStart <= 72) {
    return true;
  }
  return false;
}
